var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "2.7 25.53 2.7 5.41 47.3 5.41 47.3 25.53",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.64 9.12 43.61 9.12 43.61 25.53",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.39 25.53 6.39 9.12 21.45 9.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.02,
    y1: 25.53,
    x2: 49.26,
    y2: 25.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.74,
    y1: 25.53,
    x2: 29.87,
    y2: 25.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.78,
    cy: 22.64,
    r: 2.36,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.38,44.6a1.8,1.8,0,0,0,.52-.13,2,2,0,0,0,.93-2.4q-1-4.34-2-8.68a30.22,30.22,0,0,0,4.31-7.85,28.9,28.9,0,0,0,1-3.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.11,22.45a17.46,17.46,0,0,0-3.28-.36,15.8,15.8,0,0,0-2.38.13l-2-1.67-.19-6.13a1.39,1.39,0,0,0-.42-.94,1.35,1.35,0,0,0-2.27,1l.06,1.95-.82-1.19a3.11,3.11,0,0,1,.8-4.33l.16-.12a5.09,5.09,0,0,1,5.59,1.67c1.94,2.44,3.89,3.73,4.55,6.43A9.92,9.92,0,0,1,40.11,22.45Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 11.32,
    r: 3.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78,30.67a1.35,1.35,0,0,1-1.57-1.08c-.47-2.73-.95-5.45-1.42-8.18l-.16-5-.06-1.95a1.35,1.35,0,0,1,2.27-1,1.39,1.39,0,0,1,.42.94l.22,6.89.75,4.42.62,3.37A1.34,1.34,0,0,1,32.78,30.67Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.62,
    y1: 27.82,
    x2: 37.71,
    y2: 28.74,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.27,
    y1: 35.44,
    x2: 35.23,
    y2: 35.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.56,
    y1: 18.82,
    x2: 32.26,
    y2: 18.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,44.59l-3.78-.07a1.58,1.58,0,0,1-.17-3.15h1.39c-.4-1.36-.79-2.73-1.18-4.12s-.81-3-1.19-4.4l1-2.6a1.36,1.36,0,0,0,1.23.42,1.34,1.34,0,0,0,1.08-1.57l-.62-3.38.57-3.63",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.83,
    y1: 41.37,
    x2: 36.02,
    y2: 41.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnGoal);
export default __webpack_public_path__ + "static/media/OWN_GOAL.5ef8d55a901cea88abc5977728acfa52.svg";
export { ForwardRef as ReactComponent };